import { render } from "./icon-done.vue?vue&type=template&id=43daca3d"
const script = {}

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__